import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { DEGREE_OR_EQUILNT_ROUTE } from "../../../data/routerConstants";
import Delete from "../../common/delete";
import Edit from "../../common/edit";
import MatTable from "../../common/matTable";

const DepartmentTable = ({ data, sortColumn, onSort,onEdit, onDelete,heading }) => {
  const { t } = useTranslation(["department"]);
  const columns = [
    {
      path: "name",
      label: t("Department Name")
    },
    { path: "hodName", label: t("HoD Name") },
    { path: "hodEmail", label: t("Email") },
    { path: "hodMobile", label: t("Mobile") },
    {
      key: "actiona",
      label:"Action",
      content: (item) => (
        <><Edit title="Edit" icon="edit" onEdit={onEdit} item={item} /> 
        <Delete onDelete={onDelete} item={item} /></>
      ),
    }
  ];

  return (
    <MatTable
      heading={heading}
      data={data}
      columns={columns}
      sortColumn={sortColumn}
      onSort={onSort}
    />
  );
};

export default DepartmentTable;
